<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-form heroicon heroicon-sm"
  >
    <rect
      class="heroicon-form-clipboard heroicon-component-accent heroicon-component-fill"
      width="46"
      height="52"
      x="7"
      y="7"
      fill="#7ACFC0"
      rx="2"
    ></rect>
    <rect
      class="heroicon-form-pages heroicon-component-fill"
      width="34"
      height="44"
      x="13"
      y="10"
      fill="#FFFFFF"
    ></rect>
    <path
      class="heroicon-form-clip heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M34.97 4.4c1.73.3 3.41.73 5.03 1.3V13H20V5.7c1.62-.57 3.3-1 5.03-1.3a5 5 0 0 1 9.94 0zM30 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    ></path>
    <rect
      class="heroicon-shadows"
      width="34"
      height="6"
      x="13"
      y="49"
      fill="#000000"
      opacity=".2"
    ></rect>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M40 5.7V6h11a3 3 0 0 1 3 3v48a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h11v-.3c1.62-.57 3.3-1 5.03-1.3a5 5 0 0 1 9.94 0c1.73.3 3.41.73 5.03 1.3zm-6.85.43l-.17-1.49a3 3 0 0 0-5.96 0l-.17 1.5-1.49.24c-1.17.2-2.27.45-3.36.78V9h16V7.16c-1.1-.33-2.2-.58-3.36-.78l-1.49-.25zM20 8H9a1 1 0 0 0-1 1v48a1 1 0 0 0 1 1h42a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H40v1h8v46H12V9h8V8zm18 3v-1H22v1h16zm-24 0v37h32V11h-6v2H20v-2h-6zm32 40v-1H14v1h13v1H14v1h32v-1h-6v-1h6zM30 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm1-2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM18 17h24v1H18v-1zm0 2h23v1H18v-1zm22 3H18v-1h22v1zM18 41h24v1H18v-1zm0 2h21v1H18v-1zm5-17v-1h10v1H23zm0 3h10v1H23v-1zm0 4h10v1H23v-1zm0 4h10v1H23v-1zm-3.5-10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm.5-13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
    ></path>
  </svg>
</template>
